// extracted by mini-css-extract-plugin
export default {"notification":"Notification_notification__E3Wnn","icon":"Notification_icon__QbTM8","circle":"Notification_circle__Baud2","noComments":"Notification_noComments__9eGLe"};